import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { computed, inject } from '@angular/core';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, switchMap, tap } from 'rxjs';
import { tapResponse } from '@ngrx/component-store';
import { buildTargetPageRoutes, getWidgetsByComponentType } from '@markant-platform/widgets/util';
import { WidgetsService } from '../../services/widgets/widgets.service';
import { WidgetsState } from '@markant-platform/widgets/model';

export const INITIAL_WIDGETS_STATE: WidgetsState = {
  widgets: [],
  error: {
    type: '',
    message: '',
  },
  isLoading: false,
  isCompleteProfileDialogWidgetOpen: false,
};

export const WidgetStore = signalStore(
  withState(INITIAL_WIDGETS_STATE),
  withComputed(store => ({
    internalWidgets: computed(() => getWidgetsByComponentType(store.widgets(), 'INTERNAL')),
    externalWidgets: computed(() => getWidgetsByComponentType(store.widgets(), 'EXTERNAL')),
    targetPageRoutes: computed(() => buildTargetPageRoutes(store.widgets())),
  })),
  withMethods((store, widgetsService = inject(WidgetsService)) => ({
    toggleCompleteProfileDialogWidget(open: boolean): void {
      patchState(store, { isCompleteProfileDialogWidgetOpen: open });
    },
    getWidgets: rxMethod<void>(
      pipe(
        tap(() => patchState(store, { isLoading: true })),
        switchMap(() =>
          widgetsService.getVisibleWidgets().pipe(
            tapResponse({
              next: widgets => patchState(store, { widgets }),
              error: _ => patchState(store, { error: _ }),
              finalize: () => patchState(store, { isLoading: false }),
            })
          )
        )
      )
    ),
  }))
);
